/*eslint-disable react/no-danger*/
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';

import TextEditor from 'components/TextEditor';
import InfoBar from 'components/InfoBar';
import * as actions from 'actions';
import { getFeedbackSubject, getFeedbackTextEditing, getFeedbackEmojis, getInfoState } from 'selectors';

import './style.scss';

class Feedback extends Component {

  constructor() {
    super();

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubjectUpdate = this.handleSubjectUpdate.bind(this);
    this.handleInfoBarClose = this.handleInfoBarClose.bind(this);
  }

  handleSubmit(text) {
    const subject = this.props.subject;
    this.props.onSubmit(subject, text);
  }

  handleSubjectUpdate(e) {
    const subject = e.target.value;
    this.props.onSubjectUpdate(subject);
  }

  handleInfoBarClose() {
    if(this.props.onInfoBarClose) {
      this.props.onInfoBarClose();
    }
  }
  render() {
    return (
      <section className="content-wrapper has-background-medium">
        {this.props.isSuccessInfoBarVisible && <InfoBar onClose={this.handleInfoBarClose} isStatic type="primary" title={this.props.successInfoBarTitle} message={this.props.successInfoBarMessage} />}
        <div className="wrapper-small is-padded-top">
          <h1>{__('members.feedback.title')}</h1>

          <div className="Feedback">
            <p dangerouslySetInnerHTML={{ __html: __('members.feedback.subtitle') }} />

            <div className="feedback-form">
              <label>{__('members.feedback.form.subjectLabel')}</label>
              <input
                type="text"
                placeholder={__('members.feedback.form.subjectLabel')}
                value={this.props.subject}
                onChange={this.handleSubjectUpdate}
              />
              <TextEditor
                {...this.props}
                onSubmit={this.handleSubmit}
                maxChars={process.env.KOOTH_MAX_CHARS}
                contentTitle={__('members.feedback.form.contentLabel')}
                placeholder={__('members.feedback.form.contentPlaceholder')}
                isExpanded
                isAutosized
              />
            </div>
          </div>
        </div>
      </section>
    );
  }
}

Feedback.propTypes = {
  subject: PropTypes.string,
  isSuccessInfoBarVisible: PropTypes.bool,
  successInfoBarMessage: PropTypes.string,
  successInfoBarTitle: PropTypes.string,
  onSubjectUpdate: PropTypes.func,
  onSubmit: PropTypes.func,
  onInfoBarClose: PropTypes.func
};

const mapStateToProps = state => {
  const feedbackSubject = getFeedbackSubject(state);
  const feedbackTextEditing = getFeedbackTextEditing(state);

  const isSubmitDisabled = feedbackTextEditing.isSubmitting || !feedbackSubject.subject.length || !feedbackTextEditing.text.length;

  const successState = getInfoState(state, 'success');
  const isSuccessInfoBarVisible = successState.visible;
  const successInfoBarMessage = successState.message;
  const successInfoBarTitle = successState.title;

  return {
    ...feedbackTextEditing,
    ...feedbackSubject,
    isSubmitDisabled,
    isSuccessInfoBarVisible,
    successInfoBarMessage,
    successInfoBarTitle,
    showsEmojis: getFeedbackEmojis(state).areVisible
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onSubjectUpdate: subject => {
      dispatch(actions.feedbackEditingUpdateSubject(subject));
    },
    onTextUpdate: text => {
      dispatch(actions.feedbackEditingUpdateText({ text }));
    },
    onSubmit: (subject, text) => {
      dispatch(actions.feedbackCreate(subject, text, __('members.feedback.successMessage')));
    },
    onWillUnmount: () => {
      dispatch(actions.feedbackEmojisHide('feedback'));
      dispatch(actions.feedbackEditingReset());
    },
    onEmojisToggled: showsEmojis => {
      if(showsEmojis) {
        dispatch(actions.feedbackEmojisHide('feedback'));
      }
      else {
        dispatch(actions.feedbackEmojisShow('feedback'));
      }
    },
    onEmojiSelected: (text, emojiShortName, selectionStart) => {
      dispatch(actions.feedbackEditingUpdateText({ text, emojiShortName, selectionStart }));
    },
    onInfoBarClose: () => {
      dispatch(actions.infoClose('success'));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Feedback);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Feedback/index.js
 **/